module.exports = __webpack_public_path__ + "static/10-3d061ebc218181d4df0527da535222aa.jpg";